import { Component } from '@angular/core';
import { MssFieldBaseFieldTypeComponent } from '../mss-field-base.component';
import { MSS_FORMLY_IMPORTS } from '../../formly-standalone-imports';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

@Component({
  selector: 'lib-ff-select',
  styleUrls: ['./select.component.scss'],
  templateUrl: './select.component.html',
  imports: [MSS_FORMLY_IMPORTS, FormsModule, ReactiveFormsModule],
})
export class SelectFieldTypeComponent extends MssFieldBaseFieldTypeComponent {
  errorId?: string;
  errorDescriptionId?: string;

  public static defaultOptions: FormlyFieldConfig = {
    defaultValue: [null],
  };
}
